import { render, staticRenderFns } from "./DescricaoVaga.vue?vue&type=template&id=e91f8a4c&scoped=true"
import script from "./DescricaoVaga.vue?vue&type=script&lang=js"
export * from "./DescricaoVaga.vue?vue&type=script&lang=js"
import style0 from "./DescricaoVaga.vue?vue&type=style&index=0&id=e91f8a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91f8a4c",
  null
  
)

export default component.exports